<template>
    <div class="flex justify-center gears-container">
        <img
            class="spinning-gear small-gear"
            src="/uploads/gear_small.svg"
        />
        <img class="spinning-gear big-gear" src="/uploads/gear_big.svg" />
    </div>
</template>

<script>
export default {};
</script>

<style lang="postcss" scoped>
.gears-container {
    position: relative;
    width: 84px;
    height: 95px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
@keyframes spin-reverse {
    0% {
        transform: rotate(360deg);
    }
    100% {
        transform: rotate(0deg);
    }
}

.small-gear {
    animation-name: spin;
    top: 0px;
    left: 0px;
    animation-duration: 10s;
}

.big-gear {
    animation-name: spin-reverse;
    right: 0px;
    bottom: 0px;
    animation-duration: 17s;
}
.spinning-gear {
    position: absolute;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}
</style>